





























import Vue, { PropType } from 'vue';

export default Vue.extend({
  props: {
    id: String as PropType<string>,
    value: Array as PropType<string[] | number[]>,
    options: Array as PropType<{ text: string; value: string | number }[]>,
    state: Boolean as PropType<boolean | null>,
  },
  methods: {
    handleInput(value: string[] | number[]) {
      this.$emit('input', value);
    },
  },
});
